// extracted by mini-css-extract-plugin
module.exports =  {"container":"b429494557--container--GVCxZ","image":"b429494557--image--jBnmZ","logo":"b429494557--logo--bZ7Ni","description":"b429494557--description--ZTvPn"};